import React, { Component } from 'react';

export class Home extends Component {
    static displayName = Home.name;

    render() {
        return (
            <div>
                <h1>Welcome to OCRA Contacts!</h1>

                <hr />

                <div className="row">
                    <div className="col">
                        <a href="/contacts" className="btn btn-info btn-block">Contacts</a>
                    </div>
                    <div className="col">
                        <a href="/researchers" className="btn btn-info btn-block">Researchers</a>
                    </div>
                </div>
            </div>
        );
    }
}
